// Meldungen über das Protokoll (docs/protokoll.md, „Meldungen über das
// Protokoll"): EIN gemeinsames Abo auf das Topic `meldung` für alle Abnehmer
// (Banner/alerts-store, Ereignis-Feed, Ereignisse-Seite, Link-Verlauf,
// kritische Lage, Meldungen-Seite). Jede gespeicherte Änderung an den
// Meldungen -- neu, aktualisiert, quittiert, auch aus alert_acks -- kommt als
// Ereignis; ersetzt den WS-Kanal „events" und die Abfragen im Takt.
//
//   const aus = aufMeldung((m) => { if (m === null) alleNeuLaden(); else … });
//   aus();
//
// Die meisten Abnehmer wollen nur „bei einer Meldung gebündelt neu laden" --
// dafür `meldungRefetch` (Vorbild `wsRefetch`, lib/ws-refetch.ts):
//
//   _aus = meldungRefetch(refresh, { ms: 200, filter: betrifftEvents });
//   _aus?.();   // abmelden, räumt auch den Timer ab
//
// `null` = Lücke (Ereignisse verloren, zum Beispiel nach einem Neustart des
// Dienstes): alles neu laden. Das Abo läuft, solange mindestens ein Abnehmer
// da ist; der letzte, der geht, bestellt ab.

import { abonniere } from "./client.svelte";
import {
  meldungNachlader,
  Verteiler,
  type Abnehmer,
  type MeldungsRahmen,
  type NachladeOptionen,
} from "./meldungen-logik";

export {
  betrifftEvents,
  betrifftListe,
  buendel,
  istAckAenderung,
  type MeldungsRahmen,
  type NachladeOptionen,
} from "./meldungen-logik";

const _verteiler = new Verteiler();
let _aus: (() => void) | undefined;

/** Auf Meldungen hören; Rückgabe = abmelden. */
export function aufMeldung(fn: Abnehmer): () => void {
  const ab = _verteiler.hinzu(fn);
  if (!_aus) {
    _aus = abonniere(
      "meldung",
      {},
      {
        ereignis: (_instanz, daten) => _verteiler.verteile(daten as MeldungsRahmen),
        luecke: () => _verteiler.verteile(null),
      },
    );
  }
  return () => {
    ab();
    if (_verteiler.groesse === 0 && _aus) {
      _aus();
      _aus = undefined;
    }
  };
}

/** Bei einer Meldung `refresh` laden, gebündelt auf ein Fenster von `ms` (der
 *  erste Auftrag startet es, weitere darin laufen in denselben Lauf). Der
 *  `filter` sagt, welche Meldungen zählen; eine Lücke zählt immer. Rückgabe =
 *  abmelden, ein offenes Fenster verfällt. */
export function meldungRefetch(
  refresh: () => void | Promise<void>,
  opt: NachladeOptionen,
): () => void {
  const n = meldungNachlader(refresh, opt);
  const ab = aufMeldung(n.bei);
  return () => {
    ab();
    n.abbrechen();
  };
}
